import Vue from 'vue';

Vue.directive('dropdown', {
    bind(el, binding) {
        if (el.children.length !== 2) {
            throw new Error('v-dropdown must have exactly 2 child elements');
        }

        const toggle = el.children[0];
        const menu = el.children[1];

        let direction = 'dropdown';
        if (binding.modifiers.left) {
            direction = 'dropleft';
        } else if (binding.modifiers.right) {
            direction = 'dropright';
        } else if (binding.modifiers.up) {
            direction = 'dropup';
        }

        el.classList.add(direction);
        toggle.classList.add('dropdown-toggle');
        menu.classList.add('dropdown-menu');

        toggle.addEventListener('click', (e) => {
            e.stopPropagation();

            el.classList.toggle('show');
            menu.classList.toggle('show');
        }, false);

        menu.addEventListener('click', (e) => {
            e.stopPropagation();
        });

        window.addEventListener('click', () => {
            el.classList.remove('show');
            menu.classList.remove('show');
        }, false);
    },

    componentUpdated(el, binding) {
        const menu = el.children[1];

        if (binding.oldValue !== binding.value) {
            if (binding.value === true) {
                el.classList.add('show');
                menu.classList.add('show');
            } else if (binding.value === false) {
                el.classList.remove('show');
                menu.classList.remove('show');
            }
        }
    },
});
